import type {
  FoxKifuAiComputeMode,
  FoxKifuAiEngineWeight,
  FoxKifuAiExclusiveTier,
} from '@wx-weiqi/contracts';

export const ZHIZI_COMPUTE_MODE_LABELS: Readonly<Record<FoxKifuAiComputeMode, string>> =
  Object.freeze({
    VIP_SHARED: '智子 VIP 共享',
    EXCLUSIVE: '智子独占算力',
  });

export const ZHIZI_EXCLUSIVE_TIER_LABELS: Readonly<Record<FoxKifuAiExclusiveTier, string>> =
  Object.freeze({
    ON_DEMAND_1X: '1x 算力',
    ON_DEMAND_3X: '3x 算力',
    ON_DEMAND_6X: '6x 算力',
    ON_DEMAND_12X: '12x 算力',
    ON_DEMAND_24X: '24x 算力',
  });

export const ZHIZI_EXCLUSIVE_TIERS = Object.freeze(
  Object.keys(ZHIZI_EXCLUSIVE_TIER_LABELS) as FoxKifuAiExclusiveTier[],
);

export const ZHIZI_ENGINE_WEIGHT_LABELS: Readonly<Record<FoxKifuAiEngineWeight, string>> =
  Object.freeze({
    '18bnbt': '18bnbt',
    '28bnbt': '28bnbt',
    '20b': '20b',
    fdx: 'fdx',
    '10b384t': '10b384t',
    '10b512t': '10b512t',
    '11b768t': '11b768t',
  });

export const ZHIZI_ENGINE_WEIGHTS = Object.freeze(
  Object.keys(ZHIZI_ENGINE_WEIGHT_LABELS) as FoxKifuAiEngineWeight[],
);

export function zhiziWeightLabel(weight: string): string {
  return Object.hasOwn(ZHIZI_ENGINE_WEIGHT_LABELS, weight)
    ? (ZHIZI_ENGINE_WEIGHT_LABELS[weight] ?? weight)
    : weight;
}
